import React, { useEffect, useRef, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import {
    MdErrorOutline,
    MdOutlineTag,
    MdOutlineConfirmationNumber,
    MdOutlinePhone,
    MdOutlineCake,
    MdOutlineHome,
    MdOutlinePrint,
    MdOutlineTagFaces,
    MdOutlineNote
} from 'react-icons/md';
import StatusContainer from '../../controls/StatusContainer';
import { ESourceBg, GetESourceName } from '../../../configurations/enums/ESource';
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType';
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import { useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import LoadingContainer from '../../controls/LoadingContainer';
import { PrintStarter } from '../settings/Prints/PrintStarter';
import { ConfirmOpdPrint } from '../settings/Prints/ConfirmOpdPrint';
import { PrescriptionLetterPrint } from '../settings/Prints/PrescriptionLetterPrint';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';
import { BiSolidDonateBlood } from 'react-icons/bi';


export default function LookOutConfirmed({ isActive, searchTerm, isSearch, centerId, forDate }) {
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [loding, setLoding] = useState(false)
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [confirmData, setConfirmData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1)
    const [printData, setPrintData] = useState()
    const printRef = useRef();
    const printLetterRef = useRef();

    useEffect(() => {
        if (isActive && centerId && forDate) {
            onSearch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSearch, centerId, forDate])

    const OnPageChange = (e) => {
        if (isActive && centerId && forDate) {
            setCurrentPage(e)
            GetTodaysConfirmed({
                CenterId: centerId,
                PageNo: e,
                PageSize: PAGE_SIZE,
                SearchTerm: searchTerm,
                ForDate: forDate
            })
        }
    }

    const onSearch = () => {
        GetTodaysConfirmed({
            CenterId: centerId,
            PageNo: 1,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm,
            ForDate: forDate
        })
    }
    const GetTodaysConfirmed = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetForDateConfirmed(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setConfirmData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setConfirmData([])
                // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setConfirmData([])
            // toast.open(errors, <MdErrorOutline />, "danger")
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    // three badges: status / type / source
    const renderBadges = (item) => (
        <div className="whitespace-nowrap flex items-center gap-1.5">
            <StatusContainer bg={EOPDConfirmedStatusBg(item.status)} text={GetEOPDConfirmedStatusName(item.status)} />
            <StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} />
            <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
        </div>
    )

    // print actions
    const renderPrint = (item) => (
        <div className="flex items-center gap-1">
            <PrintStarter printRef={printRef} setPrintData={setPrintData} item={item} title="Print slip" />
            <PrintStarter printRef={printLetterRef} setPrintData={setPrintData} item={item} color='blue' title="Print prescription letter" />
        </div>
    )

    return (
        <div className="text-gray-700">
            <div style={{ display: "none" }}>
                <ConfirmOpdPrint printData={printData} ref={printRef} />
                <PrescriptionLetterPrint printData={printData} ref={printLetterRef} />
            </div>

            <Paging LastPage={LastPage} CurrentPage={currentPage} OnPageChange={OnPageChange} pagingData={pagingData}>

                {loding ? (
                    <LoadingContainer text="Fetching..." />
                ) : confirmData.length > 0 ? (
                    <>
                        {/* ===== desktop table ===== */}
                        <div className="hidden overflow-x-auto rounded-xl ring-1 ring-gray-100 sm:block">
                            <table className="w-full border-collapse text-left text-sm text-gray-500">
                                <thead>
                                    <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlinePrint className="text-sm" /> Print</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineTag className="text-sm" /> Ref.No</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineConfirmationNumber className="text-sm" /> Conf./Old</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Name</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlinePhone className="text-sm" /> Phone</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineCake className="text-sm" /> Age</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Status/Type/Source</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><BiSolidDonateBlood className="text-sm" /> BP</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineHome className="text-sm" /> Address</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineTagFaces className="text-sm" /> Bond</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineTag className="text-sm" /> Comment</span>
                                        </th>
                                        <th scope="col" className="px-3 py-3 font-semibold">
                                            <span className="flex items-center gap-1"><MdOutlineNote className="text-sm" /> Note</span>
                                        </th>

                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100">
                                    {confirmData.map((item, index) => (
                                        <tr key={item.id ?? index} className="bg-white hover:bg-gray-50">
                                            <td className="px-3 py-2.5">
                                                <div className="flex items-center justify-center gap-1">{renderPrint(item)}</div>
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.id}{item.registeredIdForRef && "/" + item.registeredIdForRef}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">
                                                <span className="font-bold text-green-500">{item.confirmedAllotedNumber}</span>/ {item.opdNumberAlloted}
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-2.5 font-bold text-gray-800">
                                                {item.patientName} <span className="text-[9px] font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </td>
                                            <td className="px-3 py-2.5">
                                                {item.mobile
                                                    ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                                                    : "—"}
                                            </td>
                                            <td className="px-3 py-2.5">{item.age}</td>
                                            <td className="px-3 py-2.5">{renderBadges(item)}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.bloodPressure}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.patientAddress}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.patientType}-{item.patientBond}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.acceptedWithComment}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.note ? item.note : "-"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* ===== mobile cards ===== */}
                        <div className="space-y-2 p-2 text-left sm:hidden">
                            {confirmData.map((item, index) => (
                                <div key={item.id ?? index} className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
                                    <div className="flex items-start justify-between gap-2">
                                        <div className="min-w-0">
                                            <div className="font-bold text-gray-900">
                                                {item.patientName} <span className="text-xs font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </div>
                                            <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-gray-500">
                                                <span className="flex items-center gap-0.5">
                                                    <MdOutlineTag className="text-sm" /> {item.id}{item.registeredIdForRef && "/" + item.registeredIdForRef}
                                                </span>
                                                <span className="flex items-center gap-0.5"><MdOutlineCake className="text-sm" /> {item.age} Y</span>
                                            </div>
                                            <div className="mt-0.5 flex items-center gap-1 text-xs text-gray-500">
                                                <MdOutlineConfirmationNumber className="text-sm" />
                                                <span>Conf/Old: <span className="font-bold text-green-600">{item.confirmedAllotedNumber}</span>/{item.opdNumberAlloted}</span>
                                            </div>
                                        </div>
                                        <div className="shrink-0">{renderPrint(item)}</div>
                                    </div>
                                    <div className="mt-2 space-y-1 text-xs text-gray-600">
                                        <div className="flex items-center gap-1">
                                            <MdOutlinePhone className="shrink-0 text-sm text-gray-400" />
                                            {item.mobile
                                                ? <a href={`tel:${item.mobile}`} className="hover:text-brand-600 hover:underline">{item.mobile}</a>
                                                : "—"}
                                        </div>
                                        <div className="flex items-start gap-1">
                                            <MdOutlineHome className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                            <span>{item.patientAddress}</span>
                                        </div>
                                        <div className="flex items-start gap-1">
                                            <MdOutlineTagFaces className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                            <span>{item.patientType}-{item.patientBond}</span>
                                        </div>
                                        <div className="flex items-start gap-1">
                                            <BiSolidDonateBlood className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                            <span>{item.bloodPressure}</span>
                                        </div>
                                        <div className="flex items-start gap-1">
                                            <MdOutlineTag className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                            <span>{item.acceptedWithComment}</span>
                                        </div>
                                        <div className="flex items-start gap-1">
                                            <MdOutlineNote className="mt-0.5 shrink-0 text-sm text-gray-400" />
                                            <span>{item.note ? item.note : "-"}</span>
                                        </div>
                                    </div>
                                    <div className="mt-2">{renderBadges(item)}</div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <Empty>No Items Found.</Empty>
                )}
            </Paging>

            <div className="pb-4" />
        </div>
    )
}